// extracted by mini-css-extract-plugin
export var container = "_cv-0";
export var popoverContent = "_cv-1";
export var tosLink = "_cv-2";